export const ToastIllustration = () => (
  <svg
    width='400'
    height='300'
    viewBox='0 0 400 300'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='400' height='300' fill='#EDF2F7' />
    <path d='M53 0H400V247H65C58.3726 247 53 241.627 53 235V0Z' fill='white' />
    <g filter='url(#filter0_d_72_225)'>
      <path
        d='M106 152.894C106 150.191 108.239 148 111 148H380C382.761 148 385 150.191 385 152.894V189.106C385 191.809 382.761 194 380 194H111C108.239 194 106 191.809 106 189.106V152.894Z'
        fill='#38B2AC'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M121 171.001C121 168.516 123.015 166.501 125.5 166.501H246.5C248.985 166.501 251 168.516 251 171.001C251 173.486 248.985 175.501 246.5 175.501H125.5C123.015 175.501 121 173.486 121 171.001Z'
      fill='#F7FAFC'
    />
    <path
      d='M354.291 177.294C354.104 177.481 353.998 177.736 353.999 178.001C353.999 178.266 354.104 178.52 354.292 178.708C354.479 178.895 354.734 179.001 354.999 179.001C355.264 179.001 355.518 178.895 355.706 178.708L361.881 172.534C361.896 172.518 361.914 172.506 361.935 172.497C361.955 172.489 361.977 172.485 361.999 172.485C362.021 172.485 362.042 172.489 362.062 172.497C362.083 172.506 362.101 172.518 362.117 172.534L368.291 178.709C368.384 178.802 368.494 178.875 368.616 178.926C368.737 178.976 368.867 179.002 368.998 179.002C369.13 179.002 369.26 178.976 369.381 178.926C369.502 178.876 369.613 178.802 369.706 178.709C369.799 178.616 369.872 178.506 369.922 178.385C369.973 178.263 369.999 178.133 369.999 178.002C369.999 177.871 369.973 177.741 369.923 177.619C369.872 177.498 369.799 177.388 369.706 177.295L363.532 171.118C363.516 171.103 363.504 171.084 363.496 171.064C363.487 171.044 363.483 171.022 363.483 171C363.483 170.978 363.487 170.957 363.496 170.936C363.504 170.916 363.516 170.898 363.532 170.882L369.707 164.708C369.895 164.52 370 164.265 370 164C370 163.734 369.894 163.48 369.706 163.293C369.519 163.105 369.264 163 368.999 163C368.733 163 368.479 163.106 368.291 163.294L362.117 169.467C362.101 169.482 362.083 169.495 362.062 169.503C362.042 169.512 362.021 169.516 361.999 169.516C361.977 169.516 361.955 169.512 361.935 169.503C361.914 169.495 361.896 169.482 361.881 169.467L355.706 163.294C355.613 163.201 355.503 163.127 355.382 163.077C355.26 163.026 355.13 163.001 354.999 163C354.734 163 354.479 163.106 354.292 163.293C354.104 163.481 353.999 163.735 353.999 164C353.998 164.266 354.104 164.52 354.291 164.708L360.465 170.882C360.481 170.898 360.493 170.916 360.502 170.936C360.51 170.957 360.514 170.978 360.514 171C360.514 171.022 360.51 171.044 360.502 171.064C360.493 171.084 360.481 171.103 360.465 171.118L354.291 177.294Z'
      fill='#F7FAFC'
    />
    <defs>
      <filter
        id='filter0_d_72_225'
        x='97'
        y='143'
        width='297'
        height='64'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='4.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_72_225'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect1_dropShadow_72_225'
          result='shape'
        />
      </filter>
    </defs>
  </svg>
)
